import {useParams, useRouteContext} from '@tanstack/react-router'
import {useMemo} from 'react'

const useLocaleParams = () => {
    const {lang} = useParams({from: '/$lang'})
    const {locale} = useRouteContext({from: '/$lang'})
    return useMemo(() => ({lang, locale}), [lang, locale])
}

export default useLocaleParams
